import { BaseHover } from './base';
import { HoverType } from '../types';
import { css } from '../../emotion';
export class Sink extends BaseHover {
    constructor(option) {
        super(HoverType.Sink);
        this.x = (option === null || option === void 0 ? void 0 : option.offsetX) || 0;
        this.y = (option === null || option === void 0 ? void 0 : option.offsetY) || -10;
    }
    animateProps() {
        return {
            from: this.generateProps({
                translateX: '0%',
                translateY: '0%',
                transform: 'perspective(1px) translateZ(0)'
            }),
            to: this.generateProps({ translateX: `${this.x}%`, translateY: `${-this.y}%` }),
            loop: {
                translateX: '0%',
                translateY: '0%',
                reverse: true
            }
        };
    }
    cssProps() {
        return css `
      display: inline-block;
      vertical-align: middle;
      box-shadow: 0 0 1px rgba(0, 0, 0, 0);
      transition-duration: 0.3s;
      transition-property: transform;
      transition-timing-function: ease-out;

      &:hover, &:focus, &:active {
        transform: perspective(1px) translateZ(0) translate(${this.x}%, ${-this.y}%);
      }
    `;
    }
}
